import React ,{useState,useEffect} from 'react'
import { Grid, Dropdown, Menu,Button,Row,Col ,Avatar, Typography } from 'antd'
import MyRightDrawer from '../MyRightDrawer'
import MyimportOrder from '../MyRightDrawer/importOrder'
import Myimportdewusku from '../MyRightDrawer/importdewusku'
import MyimportSku from '../MyRightDrawer/importSku'
import MyimportTrackingjd from '../MyRightDrawer/importOrderjdTrackingNo'
import MyimportTrackingdewu from '../MyRightDrawer/importOrderdewuTrackingNo'
import MyimportstandardProduct from '../MyRightDrawer/importStandardProduct'
import MyimportCodeiId from '../MyRightDrawer/importCodeId'
import MyimportViolation from '../MyRightDrawer/importViolation'
import ApiService from '../../utils/axios'
import WebSocketComponent from '../../utils/webSocket'
import { hasPermission } from '../../utils/permissions'
//import { inject, observer } from 'mobx-react'MyimportSku
//import { Link} from 'react-router-dom'
import UserProfile from '../../utils/Session'
import { NotificationOutlined ,
  MenuFoldOutlined ,
  MenuUnfoldOutlined,UserOutlined } from '@ant-design/icons';
const {Text} =Typography
export default function HeaderBar (props){
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open21, setOpen21] = useState(false);
  const [open22, setOpen22] = useState(false);
  const [open23, setOpen23] = useState(false);
  const [visible, setVisible] = useState(false);
  const [textwarning, setTextwarning] = useState('');
  const [purchasewarning, setPurchasewarning] = useState('');
  const [purchasedanger, setPurchasedanger] = useState('');
  useEffect(() => {

    getTableData()
  },[]);

  const getTableData =()=> {



    const data = {

    }

    ApiService.get('/upload/shippingWarning',data
    ).then(res => {
      if (res.data) {

          var tt  =''
          for (var a of res.data){
              tt = tt + a.plateform +":" + a.order_count
          }
          setTextwarning(tt)
  
        }
 
      })

      ApiService.get('/upload/purchaseWarning',data
      ).then(res => {
        if (res.data) {
  
            var purchase5days  =res.data?.[0].purchasenum_5days
            var purchase10days  =res.data?.[0].purchasenum_10days
            setPurchasewarning(purchase5days)
            setPurchasedanger(purchase10days)
          }
   
        })
    }


    const updatetskusdewu =()=> {



      const data = {
  
      }
  
      ApiService.post('/dewu/table/updatetskusdewu',data
      ).then(res => {
        if (res.data) {
  

    
          }
   
        })
  
        ApiService.post('/dewucharme/table/updatetskusdewu',data
        ).then(res => {
          if (res.data) {
    

      
            }
     
          })
      }
  
const menu = (
  <Menu className='menu'>
    <Menu.ItemGroup title='用户中心' className='menu-group'>
      <Menu.Item key ='1'>你好 - {UserProfile.getName()} </Menu.Item>
      <Menu.Item  key ='2'>个人信息</Menu.Item>
      <Menu.Item  key ='3'><a href ="/admin-login" onClick={()=>{localStorage.setItem( 'token', null)
    UserProfile.setLogin(false)
    } }> <span >退出登录</span></a> </Menu.Item>
    </Menu.ItemGroup>

    <Menu.ItemGroup title='天猫' className='menu-group'>
    <Menu.Item  key ='55'onClick={()=>setOpen22(true)}>商品id导入</Menu.Item> 
    <Menu.Item  key ='56'onClick={()=>setOpen23(true)}>处罚单导入</Menu.Item>    
    </Menu.ItemGroup>

    <Menu.ItemGroup title='得物导入' className='menu-group'>
    <Menu.Item  key ='5'onClick={()=>setOpen2(true)}>导入得物运单号</Menu.Item> 
    <Menu.Item  key ='22'onClick={()=>setOpen5(true)}>读取得物sku</Menu.Item>
    { UserProfile.getName() =='admin'? <Menu.Item   key ='33'onClick={()=>updatetskusdewu()}>更新得物sku</Menu.Item>:<></>} 
    {/*   <Menu.Item  key ='4'onClick={()=>setOpen1(true)}>导入京东订单</Menu.Item>
   
      <Menu.Item  key ='8'onClick={()=>setOpen4(true)}>导入京东运单号</Menu.Item>*/}
    
    </Menu.ItemGroup>
    {/*
    <Menu.ItemGroup title='得物导入' className='menu-group'>

    </Menu.ItemGroup>*/}
    <Menu.ItemGroup title='设置中心' className='menu-group'>
      <Menu.Item  key ='6'>个人设置</Menu.Item>
      <Menu.Item   key ='7' onClick={()=>setOpen(true)}>系统设置</Menu.Item>
    </Menu.ItemGroup>
  </Menu>
)

  const toggle = () => {
    props.onToggle()

  }//

    return (
      <>
       {hasPermission("purchase")?!screens.xs ? <WebSocketComponent />:<></>:<></>}
      <MyRightDrawer open={open} setOpen={setOpen} ></MyRightDrawer>
      <Myimportdewusku open={open5} setOpen={setOpen5} ></Myimportdewusku>
      <MyimportOrder open={open1} setOpen={setOpen1} ></MyimportOrder>
      <MyimportTrackingdewu open={open2} setOpen={setOpen2} ></MyimportTrackingdewu>
      <MyimportCodeiId open={open22} setOpen={setOpen22} ></MyimportCodeiId>
      <MyimportViolation open={open23} setOpen={setOpen23} ></MyimportViolation>
      <MyimportSku open={open3} setOpen={setOpen3} ></MyimportSku>
      <MyimportTrackingjd open={open4} setOpen={setOpen4} ></MyimportTrackingjd>
      <MyimportstandardProduct open={open21} setOpen={setOpen21} ></MyimportstandardProduct>
      <Row style={{ height: "auto", lineHeight: "normal", display: "flex", alignItems: "center" }}>
        <Col span={2}>
        <Button type="primary" className='trigger' onClick={toggle} style={{ marginBottom: 16 }}>
          {React.createElement(props.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
        </Button>
        </Col>
        {!screens.xs ?  
        <> 
        <Col span={8} style={{ display: "flex", justifyContent:"center", alignItems: "center" }}>
      

        {purchasewarning? <Text  type="warning">{"采购入库超时:"}</Text>:<></> }
        <Text style={{marginRight:"16px"}} >{purchasewarning}单</Text>
        {purchasedanger? <Text  type="danger">{"采购入库严重超时:"}</Text>:<></> }
        {purchasedanger?<Text style={{marginRight:"16px"}} >{purchasedanger}单</Text>:<></>}
        {purchasewarning> 0 ?         <a 
            href="https://www.skinmira.fr/purchase/command?tabskey=1" 
     
            rel="noopener noreferrer"
            style={{ marginRight: "16px" }}
          >
            立刻查看
          </a>:<></>
        }

        </Col>
        <Col span={12}   style={{ display: "flex", justifyContent:"center", alignItems: "center" }}>

        {textwarning? <Text  type="warning">{"发货预警:"}</Text>:<></> } 
        <Text  >{textwarning}单</Text>
        </Col>
        </>:<Col span={20}></Col>
        }
          <Col span={1}>
        {/* <Badge count={0} overflowCount={99} style={{marginRight: -17}}>
              <NotificationOutlined />
              </Badge> */}
        </Col>
        <Col span={1}>
        <Dropdown overlay={menu} placement="bottomCenter">
        
        <Avatar size="large" icon={<UserOutlined />} onClick={()=>setVisible(true)}/>
      </Dropdown>
        </Col>
      </Row>
      </>
    )
  }

/*  <WebSocketComponent></WebSocketComponent> 
      <div >

 
        <div style={{lineHeight: '64px', float: 'right'}}>
          <ul className='header-ul'>
            
            <li onClick={() => setCount(0)}>
              <Badge count={10} overflowCount={99} style={{marginRight: -17}}>
              <NotificationOutlined />
              </Badge>
            </li>
            <li>
             {login}
            </li>
          </ul>
        </div>

      </div> 
id='headerbar'
export default HeaderBar
*/
